import uuid from 'uuid/v4';
import { validUrl } from '../../utils/utils';

const INITIAL_STATE = {
  documents: null,
  last5ListenedDocuments: [],
  flags: null,
  flagsByPodcast: null,
  documentsByPodcast: null,
  podcasts: [],
  podcastsWithFlags: [],
  documentsWithFlags: [],
  template: null,
  testEmail: false,
  fetching: false,
  fetched: false,
  error: null,
  result: null,
  unsubscribedPodcasts: [],
  subscribedPodcasts: [],
  userDocument: null,
  playlists: [],
  userFieldsUpdate: null,
  userFields: null,
  newDocuments: [],
  playingDocumentId: null,
  playingDocument: null,
  listeningToDocument: false,
  playbackPlaylist: [],
  podcastsSearch: [],
  playingFromListenNowPlaylist: false,
  documentInListenNowHasFullProgress: false,
  userGroups: [],
  userGroupsSearchUsers: null,
  sharedFlagData: {
    usersId: [],
    usergroupsId: []
  },
  isSharingFlag: false,
  isCreatingGroup: false,
  userGroup: null,
  playbackFlags: [],
  notifications: null,
  deletednotifications: [],
  usersAndUserGroups: null,
  categoriesWithPodcasts: [],
  dashboardPodcastsPage: 1,
  dashboardDocumentsPage: 1,
  documentsSearchValue: '',
  discoveryDocumentsPage: 1,
  discoveryDocumentsSearchValue: ''
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'UPDATE_DISCOVERY_DOCUMENTS_SEARCH_VALUE': {
      return {
        ...state,
        discoveryDocumentsSearchValue: action.discoveryDocumentsSearchValue
      };
    }
    case 'RESET_DISCOVERY_DOCUMENTS_SEARCH_VALUE': {
      return {
        ...state,
        discoveryDocumentsSearchValue: ''
      };
    }
    case 'INCREASE_DISCOVERY_DOCUMENTS_PAGE': {
      return {
        ...state,
        discoveryDocumentsPage: state.discoveryDocumentsPage + 1
      };
    }
    case 'RESET_DISCOVERY_DOCUMENTS_PAGE': {
      return {
        ...state,
        discoveryDocumentsPage: 1
      };
    }

    case 'UPDATE_DOCUMENTS_SEARCH_VALUE': {
      return {
        ...state,
        documentsSearchValue: action.documentsSearchValue
      };
    }
    case 'RESET_DOCUMENTS_SEARCH_VALUE': {
      return {
        ...state,
        documentsSearchValue: ''
      };
    }
    case 'INCREASE_DASHBOARD_DOCUMENTS_PAGE': {
      return {
        ...state,
        dashboardDocumentsPage: state.dashboardDocumentsPage + 1
      };
    }
    case 'RESET_DASHBOARD_DOCUMENTS_PAGE': {
      return {
        ...state,
        dashboardDocumentsPage: 1
      };
    }
    case 'INCREASE_DASHBOARDS_PODCAST_PAGE': {
      return {
        ...state,
        dashboardPodcastsPage: state.dashboardPodcastsPage + 1
      };
    }
    case 'RESET_DASHBOARDS_PODCAST_PAGE': {
      return {
        ...state,
        dashboardPodcastsPage: 1
      };
    }
    case 'FETCH_DOCUMENTS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        documents: action.payload.data
      };
    }
    case 'FETCH_FLAGS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        flags: action.payload.data
      };
    }
    case 'FETCH_SUBSCRIBED_PODCASTS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        podcasts: action.payload.data
      };
    }
    case 'FETCH_FLAGS_BY_PODCASTID': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        flagsByPodcast: action.payload.data
      };
    }
    case 'FETCH_DOCUMENTS_BY_PODCASTDBID': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        documentsWithFlags: action.payload.data
      };
    }
    case 'RESET_DOCUMENTS': {
      return { ...state, fetching: false, fetched: true, documents: null };
    }
    case 'FETCH_PODCASTS_WITH_FLAGS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        podcastsWithFlags: action.payload.data
      };
    }
    case 'FETCH_DOCUMENTS_WITH_FLAGS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        documentsWithFlags: action.payload.data
      };
    }
    case 'FETCH_LAST_5_LISTENED_DOCUMENTS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        last5ListenedDocuments: action.payload.data
      };
    }
    case 'FETCH_TEMPLATE': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        template: action.payload.data
      };
    }
    case 'TEST_EMAIL': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        testEmail: action.payload.data
      };
    }
    case 'UPDATE_TAG': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        result: action.payload.data
      };
    }
    case 'UPDATE_DOCUMENT': {
      const document = action.payload.data;
      const last5ListenedDocuments = state.last5ListenedDocuments
        ? state.last5ListenedDocuments
        : [];
      if (document !== undefined) {
        const exist = last5ListenedDocuments.find(
          (epi) => epi.id === document.id
        );
        const documentIndex = last5ListenedDocuments.findIndex(
          (epi) => epi.id === document.id
        );
        if (!exist) {
          last5ListenedDocuments.pop();
          last5ListenedDocuments.unshift(document);
        } else {
          last5ListenedDocuments.splice(documentIndex, 1);
          last5ListenedDocuments.unshift(document);
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        last5ListenedDocuments
      };
    }
    case 'UPDATE_DOCUMENT_PROGRESS': {
      const { document, progress } = action.meta;

      let id = document.id;
      if (typeof document.id === 'string') {
        id = parseInt(document.id, 10);
      }
      const last5ListenedDocuments = state.last5ListenedDocuments
        ? state.last5ListenedDocuments
        : [];
      const documentIndex = last5ListenedDocuments.findIndex(
        (epi) => epi.id === id
      );
      if (documentIndex !== -1) {
        last5ListenedDocuments[documentIndex].progress = progress;
      }

      return {
        ...state,
        fetching: false,
        fetched: true,
        last5ListenedDocuments
      };
    }
    case 'INIT_PODCASTS': {
      const data = action.meta.urls;

      const unsubscribedPodcasts = data.map((rss) => initPodcast(rss));

      return {
        ...state,
        fetching: false,
        fetched: true,
        unsubscribedPodcasts: [
          ...state.unsubscribedPodcasts,
          ...unsubscribedPodcasts
        ]
      };
    }
    case 'VALIDATE_PODCAST': {
      return validateRssFeed(state, action);
    }
    case 'POST_RSS_FEED': {
      let subscribedPodcasts = [...state.subscribedPodcasts];

      if (action.payload.data) {
        subscribedPodcasts.push(action.payload.data);
      } else {
        subscribedPodcasts.push({
          id: null,
          feedUrl: action.meta.url
        });
      }
      return { ...state, fetching: false, fetched: true, subscribedPodcasts };
    }
    case 'POST_OPML': {
      const data =
        action.payload && action.payload.data
          ? action.payload.data.items.map((item) => item.xmlUrl)
          : [];

      const unsubscribedPodcasts = data.map((rss) => initPodcast(rss));

      return {
        ...state,
        fetching: false,
        fetched: true,
        unsubscribedPodcasts: [
          ...state.unsubscribedPodcasts,
          ...unsubscribedPodcasts
        ]
      };
    }
    case 'DELETE_RSS': {
      return deleteRssFeed(state, action);
    }
    case 'UPDATE_RSS_NAME': {
      return updateRssFeedName(state, action);
    }
    case 'RESET_RSS_FEED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        unsubscribedPodcasts: [],
        subscribedPodcasts: []
      };
    }
    case 'ADD_FLAG': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userFlag: action.payload.data
      };
    }
    case 'ADD_DOCUMENT': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userDocument: action.payload.data
      };
    }
    case 'FETCH_PLAYLISTS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        playlists: action.payload.data
      };
    }
    case 'UPDATE_USER_FIELDS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userFields: action.payload.data
      };
    }
    case 'FETCH_NEW_DOCUMENTS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        newDocuments: action.payload.data
      };
    }
    case 'SET_PLAYING_DOCUMENT_ID': {
      return { ...state, playingDocumentId: action.payload };
    }
    case 'SET_LISTENING_TO_DOCUMENT': {
      return { ...state, listeningToDocument: action.payload };
    }
    case 'SET_PLAYBACK_PLAYLIST': {
      return { ...state, playbackPlaylist: action.payload.documents };
    }
    case 'FETCH_CATEGORIES_PODCASTS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        categoriesWithPodcasts: action.payload.data
      };
    }
    case 'FETCH_SEARCH_PODCAST': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        podcastsSearch: action.payload.data
      };
    }
    case 'SUBSCRIBE_PODCAST': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        podcast: action.payload.data
      };
    }
    case 'SET_PLAYING_FROM_LISTEN_NOW_PLAYLIST': {
      return { ...state, playingFromListenNowPlaylist: action.payload };
    }
    case 'SET_DOCUMENT_IN_LISTEN_NOW_HAS_FULL_PROGRESS': {
      return { ...state, documentInListenNowHasFullProgress: true };
    }
    case 'RESET_LAST_5_LISTENED_DOCUMENTS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        last5ListenedDocuments: []
      };
    }
    case 'FETCH_USER_FIELDS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userFields: action.payload.data
      };
    }
    case 'RESET_APP': {
      return INITIAL_STATE;
    }
    case 'FETCH_USER_GROUPS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userGroups: action.payload.data
      };
    }
    case 'USER_GROUPS_SEARCH_USERS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userGroupsSearchUsers: action.payload.data
      };
    }
    case 'USER_GROUP_IS_SHARING_EVENT': {
      return { ...state, isSharingFlag: action.payload };
    }
    case 'USER_GROUP_SHARE_FLAG': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        isSharingFlag: false,
        sharedFlagData: {
          usersId: action.payload.data?.userIds,
          usergroupsId: action.payload.data?.userGroupIds
        }
      };
    }
    case 'USER_GROUP_CREATING_EVENT': {
      return { ...state, isCreatingGroup: action.payload };
    }
    case 'USER_GROUP_CREATE_GROUP': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userGroup: action.payload.data
      };
    }
    case 'USER_GROUP_CREATING_AND_SHARING_EVENT': {
      return { ...state, isSharingFlag: action.payload };
    }
    case 'SET_PLAYBACK_FLAGS': {
      return { ...state, playbackFlags: action.payload };
    }
    case 'FETCH_NOTIFICATIONS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        notifications: action.payload.data
      };
    }
    case 'DELETE_NOTIFICATION': {
      return { ...state, deletednotifications: action.payload.data };
    }
    case 'FETCH_USERS_AND_USER_GROUPS': {
      return { ...state, usersAndUserGroups: action.payload.data };
    }
    default:
      return state;
  }
}

const initPodcast = (rss) => {
  return {
    webPodcast: true,
    subscribed: true,
    imageUrl: null,
    artistName: null,
    podcastId: 0,
    uuid: uuid(),
    name: '',
    feedUrl: rss,
    status: 'validate',
    message: '',
    username: '',
    password: '',
    secure: false,
    duplicates: []
  };
};

const getPodcastName = (rss) => {
  return rss && rss.channel && rss.channel.title;
};

/**
 * Creates podcast entity for every RSS feed the user adds
 * @param {Object} state The redux state
 * @param {Object} action The server response for RSS validation
 */
const validateRssFeed = (state, action) => {
  const { uuid, url, username, password } = action.meta;
  const {
    payload: { data, response },
    error
  } = action;

  const subscribedPodcasts = Object.assign([], state.podcasts);
  const unsubscribedPodcasts = Object.assign([], state.unsubscribedPodcasts);

  const podcastIndex = unsubscribedPodcasts.findIndex((u) => u.uuid === uuid);
  const duplicateUrls =
    unsubscribedPodcasts
      .filter((item) => item.feedUrl === url)
      .map((item) => item.uuid) || [];
  const duplicates = duplicateUrls.length > 1 ? duplicateUrls : [];

  if (url.trim() === '') {
    return {
      ...state,
      unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
        podcast.feedUrl === url
          ? {
              ...podcast,
              status: i === podcastIndex ? 'error' : podcast.status,
              message:
                i === podcastIndex
                  ? 'Both Name and Url Feed should be provided.'
                  : podcast.message,
              duplicates
            }
          : podcast
      )
    };
  }

  if (!validUrl(url)) {
    return {
      ...state,
      unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
        podcast.feedUrl === url
          ? {
              ...podcast,
              status: i === podcastIndex ? 'error' : podcast.status,
              message:
                i === podcastIndex ? 'The Url is not valid.' : podcast.message,
              duplicates
            }
          : podcast
      )
    };
  }

  if (!error && data.status === 'ok') {
    const podcastName = getPodcastName(data.rssPayload.rss);

    if (podcastName) {
      const isSubscribedWithSameName = subscribedPodcasts.some(
        (item) => item.feedUrl === url && item.name === podcastName
      );

      const isSubscribedWithDiffName = subscribedPodcasts.some(
        (item) => item.feedUrl === url && item.name !== podcastName
      );

      if (isSubscribedWithSameName) {
        return {
          ...state,
          unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
            i === podcastIndex
              ? {
                  ...podcast,
                  name: podcastName,
                  feedUrl: url,
                  status: 'error',
                  message: 'You are already subscribed to this podcast.',
                  username:
                    podcast.secure && username && password ? username : '',
                  password:
                    podcast.secure && username && password ? password : '',
                  duplicates
                }
              : podcast
          )
        };
      }

      if (duplicates.length > 1) {
        const duplicateUrlsAndNames = [];

        return {
          ...state,
          unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) => {
            if (podcast.feedUrl === url) {
              const name = i === podcastIndex ? podcastName : podcast.name;
              if (
                duplicateUrlsAndNames.some((item) => item === `${name}${url}`)
              ) {
                return {
                  ...podcast,
                  name,
                  feedUrl: url,
                  status: 'error',
                  message:
                    'The Url appears in the table with\nthe same name, thus it will not\nbe subscribed.',
                  duplicates
                };
              }

              duplicateUrlsAndNames.push(`${name}${url}`);

              return {
                ...podcast,
                name,
                feedUrl: url,
                status: 'warning',
                message: 'The Url appears in the table more\nthan once.',
                username:
                  podcast.secure && username && password ? username : '',
                password:
                  podcast.secure && username && password ? password : '',
                duplicates
              };
            }

            return podcast;
          })
        };
      }

      return {
        ...state,
        unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) => {
          if (i === podcastIndex) {
            podcast.duplicates = [];
            return {
              ...podcast,
              name: podcastName,
              feedUrl: url,
              status: 'success',
              secure: data.secure,
              username: podcast.secure && username && password ? username : '',
              password: podcast.secure && username && password ? password : ''
            };
          }
          return podcast;
        })
      };
    }

    return {
      ...state,
      unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
        i === podcastIndex
          ? {
              ...podcast,
              name: '',
              feedUrl: url,
              status: 'error',
              message: 'The title was not found. Please add one.',
              duplicates
            }
          : podcast
      )
    };
  }

  return {
    ...state,
    unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
      i === podcastIndex
        ? {
            ...podcast,
            name: '',
            feedUrl: url,
            status: 'error',
            message:
              response && response.data && response.data.secure
                ? 'To access this podcast, you need\nto provide credentials.'
                : 'Something went wrong. Please\ncheck the RSS feed or try\nagain later.',
            secure: response && response.data && response.data.secure,
            duplicates
          }
        : podcast
    )
  };
};

/**
 * Updates podcast entity after user further interaction with the list data
 * Only when updates name or updates url to a NOT valid url or an empty url!!
 * @param {Object} state The redux state
 * @param {Object} action The podcast entity to be updated
 */
const updateRssFeedName = (state, action) => {
  const { name, feedUrl, uuid, status } = action.payload;

  const subscribedPodcasts = Object.assign([], state.podcasts);
  const unsubscribedPodcasts = Object.assign([], state.unsubscribedPodcasts);

  const podcastIndex = unsubscribedPodcasts.findIndex((u) => u.uuid === uuid);

  if (name.trim() === '') {
    return {
      ...state,
      unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
        i === podcastIndex
          ? {
              ...podcast,
              name,
              status: 'error',
              message: 'Both Name and Url Feed\nshould be provided'
            }
          : podcast
      )
    };
  }

  if (status === 'error' || status === 'warning') {
    const isSubscribedWithSameName = subscribedPodcasts.some(
      (item) => item.feedUrl === feedUrl && item.name === name
    );

    const isSubscribedWithDiffName = subscribedPodcasts.some(
      (item) => item.feedUrl === feedUrl && item.name !== name
    );

    const duplicates =
      unsubscribedPodcasts
        .filter((item) => item.feedUrl === feedUrl)
        .map((item) => item.uuid) || [];

    if (isSubscribedWithSameName) {
      return {
        ...state,
        unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
          i === podcastIndex
            ? {
                ...podcast,
                name,
                status: 'error',
                message: 'You are already subscribed to this podcast.'
              }
            : podcast
        )
      };
    }

    if (duplicates.length > 1 && validUrl(feedUrl)) {
      const duplicateUrlsAndNames = [];

      return {
        ...state,
        unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) => {
          if (podcast.feedUrl === feedUrl) {
            if (
              duplicateUrlsAndNames.some(
                (item) => item === `${podcast.name}${podcast.feedUrl}`
              )
            ) {
              return {
                ...podcast,
                name: i === podcastIndex ? name : podcast.name,
                status: 'error',
                message:
                  'The Url appears in the table with\nthe same name, thus it will not\nbe subscribed.'
              };
            }

            duplicateUrlsAndNames.push(`${podcast.name}${podcast.feedUrl}`);

            return {
              ...podcast,
              name: i === podcastIndex ? name : podcast.name,
              status: 'warning',
              message: 'The Url appears in the table more\nthan once.'
            };
          }

          return podcast;
        })
      };
    }

    return {
      ...state,
      unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
        i === podcastIndex
          ? {
              ...podcast,
              name
            }
          : podcast
      )
    };
  }

  return {
    ...state,
    unsubscribedPodcasts: state.unsubscribedPodcasts.map((podcast, i) =>
      i === podcastIndex
        ? {
            ...podcast,
            name
          }
        : podcast
    )
  };
};

const deleteRssFeed = (state, action) => {
  const podcastUuids = action.payload;

  // Remove rss feeds
  const unsubscribedPodcasts = state.unsubscribedPodcasts.filter(
    (podcast) => !podcastUuids.some((uuid) => uuid === podcast.uuid)
  );

  // Reset duplicates in table
  // Removed feedUrl
  let deletedUrls = state.unsubscribedPodcasts
    .filter((podcast) => podcastUuids.some((uuid) => uuid === podcast.uuid))
    .map((item) => item.feedUrl);

  // Check only unique feedUrl
  [...new Set(deletedUrls)].forEach((feedUrl) => {
    const duplicates =
      unsubscribedPodcasts
        .filter((item) => item.feedUrl === feedUrl)
        .map((item) => item.uuid) || [];

    if (duplicates.length > 1) {
      const duplicateUrlsAndNames = [];

      return {
        ...state,
        unsubscribedPodcasts: unsubscribedPodcasts.map((podcast, i) => {
          if (podcast.feedUrl === feedUrl) {
            if (
              duplicateUrlsAndNames.some(
                (item) => item === `${podcast.name}${podcast.feedUrl}`
              )
            ) {
              return {
                ...podcast,
                status: 'error',
                message:
                  'The Url appears in the table with\nthe same name, thus it will not\nbe subscribed.',
                duplicates
              };
            }

            duplicateUrlsAndNames.push(`${podcast.name}${podcast.feedUrl}`);

            return {
              ...podcast,
              status: 'warning',
              message: 'The Url appears in the table more\nthan once.',
              duplicates
            };
          }

          return podcast;
        })
      };
    }

    return {
      ...state,
      unsubscribedPodcasts: unsubscribedPodcasts.map((podcast, i) => {
        if (podcast.feedUrl === feedUrl) {
          podcast.duplicates = [];
          podcast.status = podcast.message.startsWith('The Url appears')
            ? 'success'
            : podcast.status;

          return podcast;
        }
        return podcast;
      })
    };
  });

  return {
    ...state,
    unsubscribedPodcasts
  };
};
